import { render } from "./QueueTab.vue?vue&type=template&id=79320a7e"
import script from "./QueueTab.vue?vue&type=script&lang=js"
export * from "./QueueTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__